module.exports = __webpack_public_path__ + "static/media/terms-es.c38a843c.md";